import { useAppSelector } from '@/app/hooks';
import { SearchBar } from '@/views/map/SearchBar/SearchBar';
import { getInitialViewState } from '@/views/map/deckglUtils';

const Search = () => {
  const viewState = useAppSelector((s) => s.analysisMap.viewState);
  const bbox = getInitialViewState()?.bbox;

  return (
    <SearchBar
      isFullScreen={true}
      mapCenter={{ lat: viewState.latitude, lng: viewState.longitude }}
      bbox={bbox}
    />
  );
};

export default Search;
